<div class="container">
  <div class="header">
    <p class="company">Derichebourg</p>
    <p class="sign-out" (click)="signout()">{{ "user.menu.sign-out" | translate }}</p>
  </div>

  <div class="user-profile">
    <img
      class="profile-picture"
      src="/assets/images/blank-profile-picture.png"
    />
    <div class="user-info">
      <p class="userName">{{ userName$ | async }}</p>
      <p class="email">{{ email$ | async }}</p>
      <p class="view-account">
        {{ "user.menu.view-account" | translate }}
        <mat-icon>launch</mat-icon>
      </p>
    </div>
  </div>

  <div class="language-container">
    <button
      mat-button
      class="language-button"
      (click)="showHideLanguageSelector($event)"
    >
      <mat-icon>language</mat-icon>
      {{ "user.menu.language" | translate }}
    </button>

    <language-selector
      class="language-selector"
      *ngIf="showLanguageSelector"
      (clickedOutside)="closeLanguageSelector()"
      (closeLanguageSelector)="closeLanguageSelector()"
      appClickOutside
    ></language-selector>
  </div>
</div>
